import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { ApplyStyles } from '@com-delta-idp/mnx-skymiles-shared';
import { Link } from '@com-delta-idp/mnx-ui-kit';
import { TooltipMetaData } from '@com-delta-omnichannel/aura';
import {
  EarnsSummary,
  EarnsSummaryAnalytics
} from './models/earns-summary.interfaces';

@Component({
  selector: 'idp-earns-summary',
  templateUrl: './earns-summary.component.html',
  styleUrls: ['./earns-summary.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EarnsSummaryComponent implements OnInit {
  @Input() content: EarnsSummary = {} as EarnsSummary;
  @Output() analyticsEvent = new EventEmitter<EarnsSummaryAnalytics>();
  tooltipData: TooltipMetaData = {} as TooltipMetaData;
  expanderStyle: ApplyStyles[] = [] as ApplyStyles[];
  dividerStyle: ApplyStyles[] = [] as ApplyStyles[];
  entryItemStyle: ApplyStyles[] = [] as ApplyStyles[];
  isMobile = false;
  descriptionStyles = [
    {
      targetClass: [
        'aura-entry-item__contents__description__action_url',
        'aura-entry-item__contents__description__data'
      ],
      rules: {
        'font-size': '14px',
        'font-family': 'Whitney-medium'
      }
    }
  ];

  actionStyles = [
    {
      targetClass: ['link'],
      rules: {
        'line-height': '20px',
        'font-family': 'Whitney-semibold'
      }
    }
  ];

  ngOnInit(): void {
    this.initCustomStyles(window.innerWidth < 768);
  }

  initCustomStyles(isMobile: boolean) {
    this.expanderStyle = !isMobile
      ? [
          {
            targetClass: ['aura-toggle-area__wrapper'],
            rules: { 'padding-right': '30px' }
          },
          {
            targetClass: ['aura-entry-item'],
            rules: { 'padding-left': '30px' }
          },
          {
            targetClass: ['aura-entry-item__contents__description__title'],
            rules: {
              'font-size': '20px',
              'line-height': '28px',
              'font-family': 'Whitney-Semibold'
            }
          }
        ]
      : [
          {
            targetClass: ['aura-entry-item__contents__description__title'],
            rules: {
              'font-size': '20px',
              'line-height': '28px',
              'font-family': 'Whitney-Semibold'
            }
          }
        ];
    this.dividerStyle = !isMobile
      ? [
          {
            targetClass: ['aura-divider'],
            rules: { width: 'unset', margin: '0 30px' }
          }
        ]
      : [
          {
            targetClass: ['aura-divider'],
            rules: { width: 'unset', margin: '0 15px' }
          }
        ];

    this.entryItemStyle = !isMobile
      ? [
          {
            targetClass: ['aura-entry-item'],
            rules: { padding: '20px 30px' }
          },
          {
            targetClass: [
              'aura-entry-item__contents__description__action_url',
              'aura-entry-item__contents__description__data'
            ],
            rules: {
              'font-size': '14px',
              'font-family': 'Whitney-medium'
            }
          }
        ]
      : [
          {
            targetClass: [
              'aura-entry-item__contents__description__action_url',
              'aura-entry-item__contents__description__data'
            ],
            rules: {
              'font-size': '14px',
              'font-family': 'Whitney-medium'
            }
          }
        ];
  }

  onLinkClick(action: Link): void {
    this.analyticsEvent.emit({
      action,
      eventType: 'click'
    });
  }

  getTooltipData(): TooltipMetaData {
    return {
      background: this.tooltipData.background,
      color: this.tooltipData.color,
      hideCloseIcon: this.tooltipData.hideCloseIcon,
      info: this.tooltipData.info,
      position: this.tooltipData.position,
      hover: this.tooltipData.hover
    };
  }
}
